import styled, { css } from 'styled-components'
import { inTo, outFrom } from './animations'

export const Container = styled.div`
  overflow: hidden;
  position: relative;
  height: 100%;
  width: 100%;
`

type WrapperProps = {
  startAnimation?: boolean
  halfLifeAnimation?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  height: 100%;
  overflow: auto;

  ${({ startAnimation, halfLifeAnimation }) => css`
    ${startAnimation && inTo}
    ${halfLifeAnimation && outFrom}
  `}
`
